__turbopack_context__.v({
  "counter": "cGijba_counter",
  "modalButtonsWrapper": "cGijba_modalButtonsWrapper",
  "productQuantityInput": "cGijba_productQuantityInput",
  "substitutesWrapper": "cGijba_substitutesWrapper",
  "unavailable": "cGijba_unavailable",
  "unavailableContent": "cGijba_unavailableContent",
  "unavailableIcon": "cGijba_unavailableIcon",
  "unavailableWrapper": "cGijba_unavailableWrapper",
  "wrapper": "cGijba_wrapper",
});
